import React, { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/tabs/tabs.module.css';
import { ChevronLeft, ChevronRight } from '@danske/sapphire-icons/react';

import { IconButton } from '../../../IconButton';
import { Icon } from '../../../Icon';
import { UnderlinedTabsProps } from '../TabsProps';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isOverflowLeft: boolean;
  isOverflowRight: boolean;
  children: ReactNode;
  onClickLeft: () => void;
  onClickRight: () => void;
  size: UnderlinedTabsProps['size'];
  isInline: boolean | undefined;
}

const OverflowWrapper = ({
  isOverflowLeft,
  isOverflowRight,
  children,
  onClickLeft,
  onClickRight,
  size = 'md',
  isInline,
  ...domProps
}: Props): JSX.Element => {
  return (
    <div
      {...domProps}
      className={clsx(
        styles['sapphire-tabs-overflow-arrows'],
        {
          [styles['sapphire-tabs-overflow-arrows--inline']]: isInline,
        },
        domProps.style
      )}
    >
      {isOverflowLeft && (
        <div
          className={clsx([
            styles['sapphire-tabs-overflow-arrows__arrow'],
            styles['sapphire-tabs-overflow-arrows__arrow--left'],
          ])}
        >
          <IconButton
            aria-hidden="true"
            onPress={onClickLeft}
            variant="tertiary"
            excludeFromTabOrder
            UNSAFE_style={{ pointerEvents: 'auto' }}
            UNSAFE_preventFocusOnPress
          >
            <Icon flexShrink={0} size={size}>
              <ChevronLeft />
            </Icon>
          </IconButton>
        </div>
      )}
      {children}

      {isOverflowRight && (
        <div
          className={clsx([
            styles['sapphire-tabs-overflow-arrows__arrow'],
            styles['sapphire-tabs-overflow-arrows__arrow--right'],
          ])}
        >
          <IconButton
            aria-hidden="true"
            onPress={onClickRight}
            variant="tertiary"
            excludeFromTabOrder
            UNSAFE_style={{ pointerEvents: 'auto' }}
            UNSAFE_preventFocusOnPress
          >
            <Icon flexShrink={0} size={size}>
              <ChevronRight />
            </Icon>
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default OverflowWrapper;
